import intl from "react-intl-universal";
import { ValutField, ValutInput, ValutSelect } from "../../Atoms/ValutInput";
import { GridFilterBar } from "./GridFilterBar";
import { fromDateInputValue, toDateInputValue } from "./gridFilterUtils";
import {
  EMPTY_DATE_AMOUNT_SUB_ACCOUNT_FILTERS,
  buildDateAmountSubAccountFilterTags,
  hasActiveDateAmountSubAccountFilters,
  isDateAmountSubAccountChipFilterActive,
  removeDateAmountSubAccountFilterTag,
} from "./dateAmountSubAccountFilters";

const POPOVER_FIELD_MAP = {
  date: { showDate: true, showAmount: false, showSubAccount: false },
  amount: { showDate: false, showAmount: true, showSubAccount: false },
};

const DateAmountSubAccountFilterForm = ({
  draft,
  onChange,
  subAccounts = [],
  showDate = true,
  showAmount = true,
  showSubAccount = true,
}) => (
  <div className="space-y-4">
    {showDate && (
      <div className="grid gap-3 sm:grid-cols-2">
        <ValutField label={intl.get("extract.dateFrom")} htmlFor="grid-filter-date-from">
          <ValutInput
            id="grid-filter-date-from"
            type="date"
            value={toDateInputValue(draft.dateFrom)}
            onChange={(event) =>
              onChange({ ...draft, dateFrom: fromDateInputValue(event.target.value) })
            }
          />
        </ValutField>
        <ValutField label={intl.get("extract.dateTo")} htmlFor="grid-filter-date-to">
          <ValutInput
            id="grid-filter-date-to"
            type="date"
            value={toDateInputValue(draft.dateTo)}
            onChange={(event) =>
              onChange({ ...draft, dateTo: fromDateInputValue(event.target.value) })
            }
          />
        </ValutField>
      </div>
    )}

    {showAmount && (
      <div className="grid gap-3 sm:grid-cols-2">
        <ValutField label={intl.get("extract.amountMin")} htmlFor="grid-filter-amount-min">
          <ValutInput
            id="grid-filter-amount-min"
            inputMode="decimal"
            placeholder="0,00"
            value={draft.amountMin}
            onChange={(event) => onChange({ ...draft, amountMin: event.target.value })}
          />
        </ValutField>
        <ValutField label={intl.get("extract.amountMax")} htmlFor="grid-filter-amount-max">
          <ValutInput
            id="grid-filter-amount-max"
            inputMode="decimal"
            placeholder="0,00"
            value={draft.amountMax}
            onChange={(event) => onChange({ ...draft, amountMax: event.target.value })}
          />
        </ValutField>
      </div>
    )}

    {showSubAccount && Array.isArray(subAccounts) && subAccounts.length >= 1 && (
      <ValutField label={intl.get("extract.subAccount")} htmlFor="grid-filter-sub-account">
        <ValutSelect
          id="grid-filter-sub-account"
          value={draft.subAccountId}
          onChange={(event) => onChange({ ...draft, subAccountId: event.target.value })}
        >
          <option value="">{intl.get("common.all")}</option>
          {subAccounts.map((sa) => (
            <option key={sa.subAccountId} value={sa.subAccountId}>
              {sa.name}
            </option>
          ))}
        </ValutSelect>
      </ValutField>
    )}
  </div>
);

export const DateAmountSubAccountFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
  subAccounts = [],
  onExport,
  onExportClick = undefined,
  chips = undefined,
}) => {
  const filterChips = chips ?? [
    { id: "date", label: intl.get("extract.filterDateTime") },
    { id: "amount", label: intl.get("extract.filterAmount") },
    { id: "more", label: intl.get("common.moreFilters") },
  ];

  return (
    <GridFilterBar
      chips={filterChips}
      filters={filters}
      emptyFilters={EMPTY_DATE_AMOUNT_SUB_ACCOUNT_FILTERS}
      onFiltersChange={onFiltersChange}
      filteredItems={filteredItems}
      onExport={onExport}
      onExportClick={onExportClick}
      buildFilterTags={(nextFilters) => buildDateAmountSubAccountFilterTags(nextFilters, subAccounts)}
      hasActiveFilters={hasActiveDateAmountSubAccountFilters}
      removeFilterTag={removeDateAmountSubAccountFilterTag}
      isChipFilterActive={isDateAmountSubAccountChipFilterActive}
      popoverFieldMap={POPOVER_FIELD_MAP}
      renderFilterForm={(draft, onChange, fieldProps) => (
        <DateAmountSubAccountFilterForm
          draft={draft}
          onChange={onChange}
          subAccounts={subAccounts}
          showDate={fieldProps.showDate !== false}
          showAmount={fieldProps.showAmount !== false}
          showSubAccount={fieldProps.showSubAccount !== false}
        />
      )}
    />
  );
};
